import { IonIcon, IonRow,IonCol, IonChip, IonToggle } from "@ionic/react";
import { chevronUp } from "ionicons/icons";
import React, { FC, useState } from "react";
import CostAvoidanceMeterTable from "./CostAvoidanceMeterTable";
import CostAvoidanceBaselineMeterTable from "./CostAvoidanceBaselineMeterTable";
import useToggle from "../../../../utils/useToggle";
import column_one from "../../../../AE2/static/icons/column-one.svg"
import column_two from "../../../../AE2/static/icons/columns-two.svg"

interface IProps {
    meter:any
};

const CostAvoidanceMeterTableContainer:FC<IProps> = ({meter}) => {
    const [rotate,toggleRotate] = useToggle(false)
    const [display,toggleDisplay] = useToggle(false)
    const [baselineData,toggleBaselineData] = useToggle(false)
    const [cols,setCols] = useState('12')
    const handleClick = () =>{
        toggleRotate()
        toggleDisplay()
    }

    const handleToggleBaselineData = ()=>{
      toggleBaselineData()
      if(baselineData){
        setCols('12')
      }
    }
    return <li className="meter-li" style={{'paddingRight':'2rem'}} >
          <div style={{display:'flex', justifyContent:'space-between'}}>
            <div style={{display:'flex'}} onClick={()=>handleClick()}>
                <IonIcon className={rotate ? "chev-icon is-rotated" : "chev-icon"} src={chevronUp}/>
                <div style={{paddingLeft:'0.6rem'}}>{meter.name} ({meter.type})</div>
            </div>
            <div hidden={!display}>
              <div>
                <IonToggle color={'light'} enableOnOffLabels={true} checked={baselineData} onClick={()=>handleToggleBaselineData()}>
                    Baseline Data
                </IonToggle>
              </div>
              <div className="pc-only" hidden={!baselineData} style={{textAlign:'right'}}>
                <IonChip color={'light'} onClick={()=>setCols('12')}>
                    <IonIcon style={{color:'white',margin:'0'}} src={column_one}/>
                </IonChip>
                <IonChip color={'light'} onClick={()=>setCols('6')}>
                  <IonIcon style={{color:'white',margin:'0'}} src={column_two}/>
                </IonChip>
              </div>
            </div>
          </div>
          <IonRow className={display ? "meter-tables-row open" : "meter-tables-row"} style={{marginTop:'0.5em'}}>
            <IonCol sizeMd={cols}>
              <div>Current & Adjusted Data ( {meter.units} )</div>
              <CostAvoidanceMeterTable meter={meter}/>
            </IonCol>
            <IonCol sizeMd={cols} hidden={!baselineData}>
                <div>Baseline Data ( {meter.units} )</div>
              <CostAvoidanceBaselineMeterTable meter={meter}/>
            </IonCol>
          </IonRow>
        </li>
};

export default CostAvoidanceMeterTableContainer;